import Constant from '@/const';
import axios from 'axios';

const getPrintPharmacy = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/pharmacy/print/${id}`),
    );
    return response.data.data;
  } catch (error) {
    throw new Error(error);
  }
};

export default getPrintPharmacy;
